module.exports = __webpack_public_path__ + "img/Logo_mod.fc0dae98.webp";